<template>
  <div class="">
    <AllRouter></AllRouter>
    <Cropper style="margin-top: 10px;"></Cropper>
    <SignCanvas></SignCanvas>
  </div>
</template>
<script>
import AllRouter from '../../components/all-router'
import SignCanvas from '../../components/sign-canvas'
import Cropper from '../../components/cropper'

export default {
  name: 'test',
  components: { AllRouter, SignCanvas, Cropper },
  props: [],
  data () {
    return {}
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
